import React, { useState, useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import Loading from './Loading'
import LoadingInline from './LoadingInline'
import Icon from './Icon'
import useData from '../hooks/useData'
import useInputValue from '../hooks/useInputValue'
import ArticleResourcesContent from './ArticleResourcesContent'
import ArticleResourcesColumn from './ArticleResourcesColumn'
import AmazonProductRow from './AmazonProductRow'
import Input from './Input'
import history from '../modules/history'
import { ButtonGroup, UncontrolledButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, InputGroupButtonDropdown } from 'reactstrap'
import Button from './Button'
import { ensureArray } from '../modules/helpers'
import { endpoint_array, searchIndex_array, rates } from '../modules/provider'
import { Sort_array } from './ArticleEdit'
import ViewMore from './ViewMore'
const uuidv4 = require('uuid/v4')

let current_query_object = {}

// const endpoint = 'FR'
const trackingID = 'cartablecuir-21'
const nb_items_per_page = 10

export const sortImages = (array) => array.sort((a, b) => (a['@attributes'].Category === 'primary' && -1) || 1)
export const truncateLink = (link) => (link && ~!!link.indexOf('?') && link.substring(0, link.indexOf('?'))) || link
export const getImageSet = (imageSet) => sortImages((Array.isArray(imageSet) && imageSet) || [imageSet])

const default_endpoint = endpoint_array.find((endpoint) => endpoint.default)

export const root_categories = [
    { label: 'Informatique', id: '340858031', us_label: 'PCHardware', crawl: true },
    { label: 'Sports et Loisirs', id: '325614031', us_label: 'SportingGoods', crawl: true },
    { label: 'Jeux vidéo', id: '530490', us_label: 'VideoGames', crawl: false },
    { label: 'High-Tech', id: '13921051', us_label: 'Electronics', crawl: false },
    { label: 'Chèques-cadeaux', id: '2524127031', us_label: 'GiftCards', crawl: false },
    { label: 'Gros électroménager', id: '908826031', us_label: 'Appliances', crawl: true },
    { label: 'Kindle (tous appareils)', id: '672108031', us_label: 'KindleStore', crawl: false },
    { label: 'Appareils Amazon et Accessoires', id: '12598689031', us_label: 'Electronics', crawl: false },

    { label: 'Jeux et jouets', id: '322086011', us_label: 'Toys', crawl: true },
    { label: 'Cuisine & Maison', id: '57004031', us_label: 'Kitchen', crawl: true },
    { label: 'Bricolage', id: '590748031', us_label: 'HomeImprovement', crawl: true },
    { label: 'Hygiène et Santé', id: '197861031', us_label: 'HealthPersonalCare', crawl: true },
    { label: 'Fournitures de bureau', id: '192419031', us_label: 'OfficeProducts', crawl: true },
    { label: 'Bébé et Puériculture', id: '206617031', us_label: 'Baby', crawl: true },
    { label: 'Animalerie', id: '1571268031', us_label: 'PetSupplies', crawl: true },
    { label: 'Épicerie', id: '3635788031', us_label: 'Grocery', crawl: false },
    { label: 'Instruments de musique et Sono', id: '340861031', us_label: 'MusicalInstruments', crawl: false },
    { label: 'Logiciels', id: '530488', us_label: 'Software', crawl: false },
    { label: 'Commerce, Industrie et science', id: '5866109031', us_label: 'Industrial', crawl: true },

    { label: 'Livres', id: '301061', us_label: 'Books', crawl: false },
    { label: 'DVD & Bluray', id: '405322', us_label: 'DVD', crawl: false },
    { label: 'Jardin', id: '3557027031', us_label: 'LawnAndGarden', crawl: true },
    { label: 'CD & Vinyles', id: '301062', us_label: 'Music', crawl: false },
    { label: 'Auto & Moto', id: '1571265031', us_label: '', crawl: false },

    { label: 'Handmade', id: '9699368031', us_label: 'Handmade', crawl: false },
    { label: 'Beauté', id: '197858031', us_label: 'Beauty', crawl: true },

    { label: 'Vêtement', id: '340855031', us_label: 'Apparel', crawl: true },
    { label: 'Chaussures et Sacs', id: '215934031', us_label: 'Shoes', crawl: true },
    { label: 'Bijoux', id: '193710031', us_label: 'Jewelry', crawl: true },
    { label: 'Montres', id: '60649031', us_label: 'Watches', crawl: true },
    { label: 'Bagagerie', id: '2454145031', us_label: 'Luggage', crawl: true },
]

const getTopNode = (node) => {
    // console.log(node)
    let candidate = node.BrowseNodeId
    if (node.Ancestors && node.Ancestors.BrowseNode) {
        candidate = getTopNode(node.Ancestors.BrowseNode)
    }
    return candidate
}
const getSearchIndex = (node) => {
    const top_node = getTopNode(node)
    // console.log({top_node})
    const searchIndex = top_node && root_categories.find((i) => i.id == top_node)
    return searchIndex && searchIndex.us_label
}

const Amazon = function Amazon(props) {
    const node_id = (props.match.params.node_id && props.match.params.node_id !== 'results' && props.match.params.node_id) || null
    const results_page = props.match.params.node_id && props.match.params.node_id === 'results'
    // const article_id = props.match.params.article_id
    let article_id,
        location_search = ''
    const [endpoint, setEndpoint] = useState(default_endpoint)
    const [page, setPage] = useState(1)
    // console.log('provider/amazon/search?endpoint=' + endpoint.value + '&AssociateTag=' + trackingID + '&Operation=BrowseNodeLookup&BrowseNodeId=' + node_id)
    const providerData = useData(
        {
            url: 'provider/amazon/search?endpoint=' + endpoint.value + '&AssociateTag=' + trackingID + '&Operation=BrowseNodeLookup&BrowseNodeId=' + node_id,
            transform: (data) => data.BrowseNodes.BrowseNode,
        },
        [node_id]
    )
    // console.log({ providerData })
    const node = (providerData.isReady && providerData.data) || {}

    const searchIndex = node && getSearchIndex(node)
    const topSellers = useData(
        {
            url:
                'provider_top_seller?provider=amazon&scope=crawl&SearchIndex=' +
                searchIndex +
                '&external_provider_node_id=' +
                node.BrowseNodeId +
                '&endpoint=' +
                endpoint.value +
                '&AssociateTag=' +
                trackingID +
                '&page=1',
        },
        [node.BrowseNodeId]
    )
    console.log({ topSellers })

    const ItemId =
        (node &&
            node.TopItemSet &&
            node.TopItemSet.TopItem &&
            ensureArray(node.TopItemSet.TopItem)
                .map((item) => item.ASIN)
                .join(',')) ||
        null

    // get details of TopSellers from node object
    const ProductDetailsFromNode = useData(
        'provider/amazon/search?Operation=ItemLookup&ItemId=' + ItemId + '&IdType=ASIN&endpoint=' + endpoint.value + '&AssociateTag=' + trackingID,
        [node, ItemId]
    )
    // console.log({ ProductDetailsFromNode })

    const ProductDetailsUrl =
        (searchIndex &&
            'provider/amazon/search?Operation=ItemSearch&SearchIndex=' +
                searchIndex +
                '&BrowseNode=' +
                node_id +
                '&endpoint=' +
                endpoint.value +
                '&AssociateTag=' +
                trackingID +
                '&Sort=salesrank') ||
        'provider/amazon/search?Operation=ItemLookup&ItemId=' + ItemId + '&IdType=ASIN&endpoint=' + endpoint.value + '&AssociateTag=' + trackingID
    useEffect(() => {
        setPage(1)
    }, [node_id])
    const ProductDetails = useData({ page, paginate: ({ url, params, page }) => ({ url: url + '&ItemPage=' + page, params }), url: ProductDetailsUrl }, [
        node,
        searchIndex || ItemId,
    ])
    // console.log({ ProductDetails })

    let BrowseNode = (node && node.Children && node.Children.BrowseNode) || null
    BrowseNode = (BrowseNode && !Array.isArray(BrowseNode) && [BrowseNode]) || BrowseNode

    let productArray =
        (typeof ProductDetails.paginated !== 'undefined' && ProductDetails.paginated.length && ensureArray(ProductDetails.paginated)) ||
        (typeof ProductDetails.data !== 'undefined' && ProductDetails.data.length && [{ data: ensureArray(ProductDetails.data) }]) ||
        []
    // console.log({ productArray })

    const ProductDetailsFromNodeArray = (ProductDetailsFromNode.isReady && ProductDetailsFromNode.data.Items && ensureArray(ProductDetailsFromNode.data)) || []
    // console.log({ProductDetailsFromNodeArray})
    const onArticleChange = (article_id) => history.push(`/provider/amazon/${node_id || ''}${(article_id && '?article_id=' + article_id) || ''}`)

    const siteArray = useData('site')

    const [searchPage, setSearchPage] = useState(1)
    const trackingID_array = (siteArray.isReady && siteArray.data.map((site) => site.tracking_id).filter(Boolean)) || []
    const [query, setQuery] = useState('')
    const queryField = useInputValue('')
    const [searchTrackingID, setSearchTrackingID] = useState(null)
    console.log({ searchTrackingID })
    const [SearchIndex, setSearchIndex] = useState(searchIndex_array[0].label)
    const [searchIndexToggle, setSearchIndexToggle] = useState(false)
    const [Sort, setSort] = useState(Sort_array.find((item) => item.default).value)
    const [endpointToggle, setEndpointToggle] = useState(false)
    const [trackingIDToggle, setTrackingIDToggle] = useState(false)
    const [SortToggle, setSortToggle] = useState(false)
    const setCurrentTrackingID = (value) => setSearchTrackingID(trackingID_array.find((trackingID) => trackingID === value))
    const setCurrentEndpoint = (value) => setEndpoint(endpoint_array.find((endpoint) => endpoint.value === value))
    const [Available] = useState(true)
    const [Brand] = useState('')
    const [Manufacturer] = useState('')
    const [MinimumPrice] = useState('')
    const [MaximumPrice] = useState('')
    const [unique_query_id, setUniqueQueryID] = useState(uuidv4())
    const [searchCount, setSearchCount] = useState(0)

    const toggleEndpoint = () => setEndpointToggle(!endpointToggle)
    const toggleSort = () => setSortToggle(!SortToggle)
    // const toggleTrackingID = () => setTrackingIDToggle(!trackingIDToggle)
    const toggleSearchIndex = () => setSearchIndexToggle(!searchIndexToggle)

    const handleSearchInputKeyPress = (e) => {
        queryField.onChange(e)
    }
    const triggerQuery = (e) => {
        e && e.preventDefault()
        history.push('/provider/amazon/results')
        setQuery(queryField.value)
        setSearchCount(searchCount + 1)
    }

    const query_url = useMemo(() => {
        let query_keywords = queryField.value
        let query_searchIndex = SearchIndex
        let query_Available = Available
        let query_Brand = Brand
        let query_Manufacturer = Manufacturer
        let query_MinimumPrice = MinimumPrice
        let query_MaximumPrice = MaximumPrice
        let query_Sort = Sort
        const unique_id = uuidv4()
        let log = true
        setUniqueQueryID(unique_id)
        if (query_searchIndex === 'All') {
            query_Sort = undefined
        }
        const query = {
            id: unique_id,
            keywords: query_keywords,
            endpoint: endpoint.value,
            trackingID,
            // site_id: props.article.site_id,
            category: query_searchIndex,
            available: query_Available,
            Brand: query_Brand,
            Manufacturer: query_Manufacturer,
            MinimumPrice: query_MinimumPrice,
            MaximumPrice: query_MaximumPrice,
            Sort: query_Sort,
        }
        current_query_object = query
        if (log) {
            // props.setQueryHistory([...props.query_history, query])
            // localStorage.setItem('query_history', JSON.stringify([...props.query_history, query]))
        }
        return (
            'provider/amazon/search?keywords=' +
            query_keywords +
            '&SearchIndex=' +
            query_searchIndex +
            '&endpoint=' +
            endpoint.value +
            '&AssociateTag=' +
            searchTrackingID +
            ((query_Available && '&Availability=Available') || '') +
            ((query_Brand && '&Brand=' + Brand) || '') +
            ((query_Manufacturer && '&Manufacturer=' + query_Manufacturer) || '') +
            ((query_MinimumPrice && '&MinimumPrice=' + query_MinimumPrice * 100) || '') +
            ((query_MaximumPrice && '&MaximumPrice=' + query_MaximumPrice * 100) || '') +
            ((!!query_Sort && '&Sort=' + query_Sort) || '')
        )
    }, [searchCount])

    const AmazonSearch = useData(
        {
            url: query_url,
            page: searchPage,
            paginate: ({ url, params, page }) => ({ url: url + '&ItemPage=' + searchPage, params }),
        },
        [!node_id, endpoint.value, query && query.length]
    )

    const Categories = () => (
        <ul className="list-unstyled text-left" style={{ columnCount: '3' }}>
            {root_categories
                .sort((a, b) => a.label.localeCompare(b.label))
                .map((n) => (
                    <li key={`${n.id}`}>
                        <Link to={`/provider/amazon/${n.id}${location_search}`}>{n.label}</Link>
                        {/* {n.id===node_id&& BrowseNode &&
                        BrowseNode.map(item => (
                            <Link to={`/provider/amazon/${item.BrowseNodeId}${location_search}`} key={'bn'+item.BrowseNodeId}>
                                {item.Name} ({item.BrowseNodeId})>
                            </Link>
                        ))} */}
                    </li>
                ))}
        </ul>
    )

    console.log({ AmazonSearch })

    return (
        <>
            <ArticleResourcesContent onArticleChange={onArticleChange} article_id={article_id}>
                <div className="row">
                    <div className={'col-md-9 col-xxl-7'}>
                        <div id="block-toolbar-container-top" className="pb-3 pt-0">
                            <form className="w-100 pt-3" onSubmit={triggerQuery}>
                                <div className="input-group mb-3">
                                    <Input type="text" {...queryField} id="query-field" onChange={handleSearchInputKeyPress} />
                                    <InputGroupButtonDropdown addonType="append" isOpen={searchIndexToggle} toggle={toggleSearchIndex}>
                                        <DropdownToggle caret color="light">
                                            {SearchIndex}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {searchIndex_array.map(({ label }) => (
                                                <DropdownItem key={`SearchIndex-item-${label}`} onClick={() => setSearchIndex(label)}>
                                                    {label}
                                                </DropdownItem>
                                            ))}
                                        </DropdownMenu>
                                    </InputGroupButtonDropdown>
                                    <InputGroupButtonDropdown addonType="append" isOpen={SortToggle} toggle={toggleSort}>
                                        <DropdownToggle caret color="light">
                                            {Sort_array.find((item) => item.value === Sort).label}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {Sort_array.map((Sort) => (
                                                <DropdownItem key={`Sort-item-${Sort.value}`} onClick={() => setSort(Sort.value)}>
                                                    {Sort.label}
                                                </DropdownItem>
                                            ))}
                                        </DropdownMenu>
                                    </InputGroupButtonDropdown>
                                    {/* <InputGroupButtonDropdown addonType='append' isOpen={trackingIDToggle} toggle={toggleTrackingID}>
                                        <DropdownToggle caret color='light'>
                                            {trackingID}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {trackingID_array.map(trackingID => (
                                                <DropdownItem key={`trackingID-item-${trackingID}`} onClick={() => setCurrentTrackingID(trackingID)}>
                                                    {trackingID}
                                                </DropdownItem>
                                            ))}
                                        </DropdownMenu>
                                    </InputGroupButtonDropdown> */}
                                    <InputGroupButtonDropdown addonType="append" isOpen={endpointToggle} toggle={toggleEndpoint}>
                                        <DropdownToggle caret color="light">
                                            {endpoint.label}
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {endpoint_array.map((endpoint) => (
                                                <DropdownItem key={`endpoint-item-${endpoint.value}`} onClick={() => setCurrentEndpoint(endpoint.value)}>
                                                    {endpoint.label}
                                                </DropdownItem>
                                            ))}
                                        </DropdownMenu>
                                    </InputGroupButtonDropdown>
                                    <div className="input-group-append">
                                        <Button {...AmazonSearch} className="btn-amazon" onClick={triggerQuery}>
                                            <Icon name="amazon" /> SEARCH
                                        </Button>
                                    </div>
                                </div>
                            </form>
                            {!results_page && providerData.isReady && (
                                <>
                                    <Link to={'/provider/amazon' + location_search}>
                                        <Icon name="amazon" />
                                    </Link>
                                    {node.Ancestors && <Ancestor {...node.Ancestors} location_search={location_search} />}
                                    <Icon name="angle-right" className="mx-1" />
                                    {node.Name}
                                    {(BrowseNode && BrowseNode.length && (
                                        <ButtonGroup>
                                            <UncontrolledButtonDropdown size="sm" color="link">
                                                <DropdownToggle color="link">
                                                    <Icon name="angle-down" />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    {BrowseNode &&
                                                        BrowseNode.map((item) => (
                                                            <DropdownItem
                                                                onClick={() => props.history.push(`/provider/amazon/${item.BrowseNodeId}${location_search}`)}
                                                                key={item.BrowseNodeId}
                                                            >
                                                                {item.Name} ({item.BrowseNodeId})&gt;
                                                            </DropdownItem>
                                                        ))}
                                                </DropdownMenu>
                                            </UncontrolledButtonDropdown>
                                        </ButtonGroup>
                                    )) ||
                                        null}
                                    {(topSellers.isReady && topSellers.data && topSellers.data.average_commission && (
                                        <small className="d-inline-block ml-2 text-muted">
                                            top seller average: {topSellers.data.average_commission / 100} EUR
                                        </small>
                                    )) || <LoadingInline className="ml-2" />}
                                    <hr className="mb-1" />
                                </>
                            )}
                            <small className="d-block w-100 text-center">
                                {(!results_page && !node_id && <Categories />) || (
                                    <ViewMore more="Show Categories" less="Hide categories">
                                        <Categories />
                                    </ViewMore>
                                )}
                            </small>
                        </div>

                        {(results_page && (
                            <>
                                {AmazonSearch.paginated && (
                                    <>
                                        <table className="table" style={{ overflow: 'hidden' }}>
                                            <tbody>
                                                {AmazonSearch.paginated.map((pa, pa_index) =>
                                                    ensureArray(pa.data).map((p, index) => (
                                                        <AmazonProductRow
                                                            index={nb_items_per_page * pa_index + (index + 1)}
                                                            key={`ap-${p.ASIN}`}
                                                            {...p}
                                                            reviews={true}
                                                            description={true}
                                                            origin="amazon"
                                                            originalUrl={'amazon'}
                                                            displayUrl={'amazon'}
                                                        />
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                        <div className="text-center mb-3 pb-3">
                                            {(AmazonSearch.isLoading && (
                                                <div className="mb-1">
                                                    <Loading no_space={(searchPage > 1 && true) || false} text="Loading top sellers products from Amazon" />
                                                </div>
                                            )) ||
                                                (AmazonSearch.isReady && (
                                                    <button className="btn btn-link btn-sm" onClick={() => setSearchPage(searchPage + 1)}>
                                                        More <Icon name="angle-down" />
                                                    </button>
                                                )) ||
                                                null}
                                        </div>
                                    </>
                                )}
                            </>
                        )) ||
                            null}

                        {!results_page && providerData.isReady && (
                            <>
                                {(productArray && productArray.length && (
                                    <>
                                        <table className="table table-responsive-sm mt-3">
                                            <tbody className="w-100">
                                                {productArray.map((pa, pa_index) =>
                                                    ensureArray(pa.data).map((p, index) => (
                                                        <React.Fragment key={`ap-${p.ASIN}`}>
                                                            {(pa_index === 0 &&
                                                                ProductDetailsFromNode.isReady &&
                                                                ProductDetailsFromNodeArray[index] &&
                                                                !ensureArray(pa.data).find((ppp) => ppp.ASIN === ProductDetailsFromNodeArray[index].ASIN) && (
                                                                    <AmazonProductRow
                                                                        index={`${nb_items_per_page * pa_index + (index + 1)}*`}
                                                                        {...ProductDetailsFromNodeArray[index]}
                                                                        reviews={true}
                                                                        description={true}
                                                                        origin="amazon"
                                                                        originalUrl={'amazon'}
                                                                        displayUrl={'amazon'}
                                                                        location_search={location_search}
                                                                    />
                                                                )) ||
                                                                null}
                                                            <AmazonProductRow
                                                                index={nb_items_per_page * pa_index + (index + 1)}
                                                                key={`ap-${p.ASIN}`}
                                                                {...p}
                                                                reviews={true}
                                                                description={true}
                                                                origin="amazon"
                                                                originalUrl={'amazon'}
                                                                displayUrl={'amazon'}
                                                                location_search={location_search}
                                                            />
                                                        </React.Fragment>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </>
                                )) ||
                                    null}
                                <div className="text-center mb-3 pb-3">
                                    {(ProductDetails.isLoading && !providerData.isLoading && (
                                        <div className="mb-1">
                                            <Loading no_space={(page > 1 && true) || false} text="Loading top sellers products from Amazon" />
                                        </div>
                                    )) || (
                                        <button className="btn btn-link btn-sm" onClick={() => setPage(page + 1)}>
                                            More <Icon name="angle-down" />
                                        </button>
                                    )}
                                </div>
                            </>
                        )}
                        {(!node_id && !results_page && (
                            <>
                                {/* <Link to='/provider/amazon'>
                                        <Icon name='amazon' /> Home
                                    </Link> */}
                            </>
                        )) ||
                            null}
                        {(providerData.isLoading && <Loading text="Loading categories data from Amazon" />) || null}
                    </div>

                    {
                        <div className="col-md-3 col-xxl-5">
                            {<ArticleResourcesColumn grabText={true} origin={'amazon'} originalUrl={'amazon'} displayUrl={'amazon'} />}
                        </div>
                    }
                </div>
            </ArticleResourcesContent>
        </>
    )
}

export const Ancestor = (props) => {
    const node_array = ensureArray(props.BrowseNode)
    return (
        <span>
            {node_array.map(
                (node) => (node.Ancestors && <Ancestor key={node.BrowseNodeId} {...node.Ancestors} location_search={props.location_search || ''} />) || null
            )}
            <Icon name="angle-right" className="mx-1" />
            {node_array.map(
                (node) =>
                    (
                        <Link to={'/provider/amazon/' + node.BrowseNodeId + (props.location_search || '')} key={node.BrowseNodeId}>
                            {node.Name}
                        </Link>
                    ) || null
            )}
        </span>
    )
}
export const BrowseNode = (props) => BrowseNode.Name
export const getAffiliateFeeString = (Nodes, price) => {
    const value = getAffiliateFee(Nodes, price)
    if (value) {
        const { CurrencyCode, amount, rate } = value
        return `${CurrencyCode} ${amount} (${rate}%)`
    }
    return null
}
export const getAffiliateFee = (Nodes, price) => {
    const rate = getRate(Nodes)
    if (rate && price && price.Amount) {
        return { CurrencyCode: price.CurrencyCode, amount: ((parseInt(price.Amount) * rate) / 100 / 100).toFixed(2), rate }
    }
    return null
}
export const getRate = (Nodes, rate) => {
    if (!Array.isArray(Nodes)) {
        Nodes = [Nodes]
    }
    Nodes.map((Node) => {
        // console.log('found getRate', Node.BrowseNode)
        if (Array.isArray(Node.BrowseNode)) {
            Node.BrowseNode.map((N) => {
                // console.log('found, calling recursive now')
                rate = rate || getRate({ BrowseNode: N }, rate)
            })
        }
        if (Node.BrowseNode && Node.BrowseNode.Ancestors) {
            // console.log('found, calling with Ancestors')
            rate = rate || getRate(Node.BrowseNode.Ancestors, rate)
        }
        if (Node.BrowseNode) {
            // console.log('found, calling getRateForThisNode')
            rate = rate || getRateForThisNode(Node.BrowseNode, rate)
            // console.log(Node.BrowseNode.BrowseNodeId, 'found rate:', rate)
        }
    })
    return rate
}
export const getRateForThisNode = (Nodes) => {
    if (!Array.isArray(Nodes)) {
        Nodes = [Nodes]
    }
    // console.log('getRateForThisNode', {Nodes})
    // console.log('getRateForThisNode', {Nodes})
    const value = Nodes.reduce((acc, Node) => {
        // console.log(Node.BrowseNodeId)
        rates.map(({ rate, BrowseNodes }) => {
            const candidate = BrowseNodes && BrowseNodes.find((BrowseNodeCandidate) => BrowseNodeCandidate.id === Node.BrowseNodeId)
            if (candidate) {
                // console.log('FOUND RATE', rate)
                acc = rate
            }
        })
        return acc
    }, 0)
    // console.log('RETURNING', value)
    return value
}

// export const BrowseNodes = React.memo(props => {
//     if (Array.isArray(props.BrowseNode)) {
//         return (
//             <React.Fragment>
//                 {props.BrowseNode.map((BrowseNode, index) => (
//                     <React.Fragment key={BrowseNode.BrowseNodeId}>
//                         {(index > 0 && ', ') || ''}
//                         <BrowseNodes BrowseNode={BrowseNode} location_search={props.location_search} />
//                     </React.Fragment>
//                 ))}
//             </React.Fragment>
//         )
//     } else {
//         return (
//             (props.BrowseNode && (
//                 <React.Fragment>
//                     {(props.BrowseNode.Ancestors && (
//                         <React.Fragment>
//                             <BrowseNodes {...props.BrowseNode.Ancestors} location_search={props.location_search} />
//                             <Icon name='angle-right' className='mx-1' />
//                         </React.Fragment>
//                     )) ||
//                         null}
//                     <Link to={`/provider/amazon/${props.BrowseNode.BrowseNodeId}${props.location_search || ''}`}>{props.BrowseNode.Name}</Link>
//                 </React.Fragment>
//             )) ||
//             null
//         )
//     }
// })
export const NodeArray = (props) => {
    const { node_array, ...rest } = props
    return (node_array || []).map((node) => (
        <div key={node.id}>
            <Node {...node} {...rest} />
        </div>
    ))
}
export const Node = React.memo((props) => {
    return (
        <>
            {(props.ancestor && (
                <>
                    <Node {...props.ancestor} location_search={props.location_search} />
                    <Icon name="angle-right" className="mx-1" />
                </>
            )) ||
                null}
            <Link to={`/provider/amazon/${props.id}${props.location_search || ''}`}>{props.label}</Link>
        </>
    )
})

export class Variations extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = { selected_variation: (this.props.Item && this.props.Item[0] && this.props.Item[0].ASIN) || null }
    }

    selectVariation = (selected_variation) => {
        this.setState({ selected_variation })
    }

    render() {
        const selected_item =
            (this.state.selected_variation && ensureArray(this.props.Item).find((item) => item.ASIN === this.state.selected_variation)) || null
        const image_set =
            (selected_item &&
                selected_item.ImageSets &&
                selected_item.ImageSets.ImageSet &&
                ((Array.isArray(selected_item.ImageSets.ImageSet) && selected_item.ImageSets.ImageSet) || [selected_item.ImageSets.ImageSet])) ||
            []
        let variation_attribute =
            selected_item &&
            selected_item.VariationAttributes &&
            selected_item.VariationAttributes.VariationAttribute &&
            selected_item.VariationAttributes.VariationAttribute
        variation_attribute = (variation_attribute && ((Array.isArray(variation_attribute) && variation_attribute) || [variation_attribute])) || null
        return (
            <React.Fragment>
                <div className="controlled-width">
                    <ul className="pagination pagination-xs mt-3">
                        {ensureArray(this.props.Item).map((item, index) => (
                            <li className={'page-item' + ((this.state.selected_variation === item.ASIN && ' active') || '')} key={item.ASIN + '-' + index}>
                                <a
                                    className="page-link"
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault()
                                        this.selectVariation(item.ASIN)
                                    }}
                                >
                                    {index + 1}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
                <ul className="list-unstyled">
                    {(image_set &&
                        image_set.map((image, index) => (
                            <li
                                key={image.MediumImage.URL + '-' + index}
                                className={
                                    'd-inline-block amazon-selector-image mr-2' +
                                    ((this.props.ItemClickCallback && ' pointer') || '') +
                                    ((this.props.currentBench &&
                                        this.props.currentBench.find((product) => product.image_url === image.LargeImage.URL) &&
                                        ' amazon-selector-selected-image') ||
                                        '')
                                }
                            >
                                <div className="d-flex justify-content-center">
                                    <React.Fragment>
                                        {(this.props.currentBench && this.props.currentBench.find((product) => product.image_url === image.LargeImage.URL) && (
                                            <Icon name="check" className={'icon-check '} key={'selected-' + index} />
                                        )) ||
                                            null}
                                    </React.Fragment>
                                    <img
                                        src={image.MediumImage.URL}
                                        className="img-fluid align-self-center"
                                        onClick={(this.props.ItemClickCallback && ((e) => this.props.ItemClickCallback(image.LargeImage.URL))) || undefined}
                                    />
                                </div>
                            </li>
                        ))) ||
                        null}
                </ul>
                {(variation_attribute &&
                    variation_attribute.map((attribute) => (
                        <small key={attribute.Name + attribute.Value}>
                            <dl>
                                <dt>{attribute.Name}</dt>
                                <dd>{attribute.Value}</dd>
                            </dl>
                        </small>
                    ))) ||
                    null}
            </React.Fragment>
        )
    }
}

export default Amazon
